/**
 * Validate the final partner hand-off before navigation.
 *
 * A missing, javascript:, relative or off-network URL must never be opened
 * or counted as an affiliate conversion. Only the configured distributor
 * hosts and Travelpayouts redirect hosts are accepted.
 */
const PARTNER_HOSTS = [
  'aviasales.com', 'booking.com', 'travelpayouts.com', 'tp.media',
  'tp.st', 'hotels.com', 'agoda.com', 'trivago.com',
  'kiwitaxi.com', 'localrent.com',
];

export function isSafePartnerUrl(value) {
  if (typeof value !== 'string' || !value.trim()) return false;
  try {
    const u = new URL(value.trim());
    if (u.protocol !== 'https:' || u.username || u.password) return false;
    const hostname = u.hostname.toLowerCase();
    return PARTNER_HOSTS.some(host => hostname === host || hostname.endsWith(`.${host}`));
  } catch {
    return false;
  }
}

export function safePartnerUrl(value) {
  if (!isSafePartnerUrl(value)) return '';
  return new URL(value.trim()).toString();
}

/**
 * Provider category contract: being on the global allowlist does not make
 * Aviasales a HOTEL supplier, or Booking.com a FLIGHT supplier.
 *
 * Generic Travelpayouts tracking domains are intentionally not accepted
 * for an unverified flight/hotel deep link: the final destination is hidden
 * behind an HTTP redirect and must be verified commercially first.
 */
const FLIGHT_HOSTS = ['aviasales.com'];
const HOTEL_HOSTS = ['booking.com', 'hotels.com', 'agoda.com', 'trivago.com'];

export function safePartnerUrlForType(value, type) {
  const parsed = safePartnerUrl(value);
  if (!parsed) return '';
  const host = new URL(parsed).hostname.toLowerCase();
  const allowed = type === 'flight' ? FLIGHT_HOSTS
    : type === 'hotel' ? HOTEL_HOSTS
      : [];
  return allowed.some(name => host === name || host.endsWith(`.${name}`))
    ? parsed : '';
}

/** Server analytics must record the *actual* provider, not card metadata. */
export function partnerNameFromUrl(value) {
  const parsed = safePartnerUrl(value);
  if (!parsed) return null;
  const hostname = new URL(parsed).hostname.toLowerCase();
  return PARTNER_HOSTS.find(host => hostname === host || hostname.endsWith(`.${host}`)) || null;
}
